import labels from './labels';

function applyDocumentLocale(locale) {
  document.documentElement.lang = locale;
  document.documentElement.dir = locale === 'he' ? 'rtl' : 'ltr';
}

export default {
  data() {
    return {
      locale: localStorage.getItem('compopo_lang') || 'en',
    };
  },
  methods: {
    $l(key) {
      return (labels[key] && labels[key][this.locale]) || (labels[key] && labels[key].en) || key;
    },
    setLocale(locale) {
      this.locale = locale;
      localStorage.setItem('compopo_lang', locale);
      applyDocumentLocale(locale);
      this.$root.$emit('locale-changed', locale);
    },
  },
  mounted() {
    applyDocumentLocale(this.locale);
    this.$root.$on('locale-changed', (locale) => {
      this.locale = locale;
    });
  },
};
